import React from "react";
import { Box, Card, Typography, Grid } from "@mui/material";
import { DecorativeCorner } from "../common/DecorativeCorner";


const FounderSection = ({ styles }) => {
	const founderImageStyles = {
		width: "100%",
		height: "auto",
		display: "block",
	};

	const descriptionStyles = {
		fontFamily: '"Inter var"',
		fontWeight: 400,
		fontSize: { xs: '15px', sm: '26px' },
		lineHeight: { xs: '20px', sm: '46px' },
		letterSpacing: "0%",
		textAlign: "justify",
	};

	return (
		<Card
			sx={{
				...styles.payuse,
				height: { xs: "auto", sm: 615 },
				padding: { xs: 2, sm: 4 },
			}}
		>
			<DecorativeCorner
				sx={{ top: -20, left: -20, transform: "rotate(0deg)" }}
			/>
			<DecorativeCorner
				sx={{ top: -20, right: -20, transform: "rotate(0deg)" }}
			/>
			<DecorativeCorner
				sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }}
			/>
			<DecorativeCorner
				sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }}
			/>

			<Box
				sx={{
					position: { xs: "relative", md: "absolute" },
					top: { xs: 30, md: "40px" },
					left: { xs: 0, md: "70px" },
					width: "100%",
					display: "flex",
					justifyContent: { xs: "center", md: "flex-start" },
					mb: { xs:0, md: 0 },
				}}
			>
				<Box
					sx={{
						position: "absolute",
						top: -8,
						left: 10,
						width: { xs: '200px', sm: "296px" },
						height: "94px",
						border: "2px solid #d67e29",
						borderRadius: "0px 40px 0px 40px",
						zIndex: 0,
					}}
				/>

				<Box
					sx={{
						position: "relative",
						backgroundColor: "#d67e29",
						color: "#fff",
						width: { xs: '180px', sm: "296px" },
						height: "76px",
						borderRadius: "0px 40px 0px 40px",
						fontWeight: "bold",
						zIndex: 1,
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<Typography
						variant="h6"
						component="div"
						sx={{
							fontFamily: '"Inter var"',
							fontWeight: 600,
							fontSize: { xs: "20px", sm: "32px" },
							lineHeight: "100%",
							letterSpacing: "0%",
						}}
					>
						About Founder
					</Typography>
				</Box>
			</Box>
			<Grid
				container
				spacing={3}
				sx={{
					marginTop: { xs: 2, md: "80px" },
					padding: { xs: 2, md: "20px 0" },
				}}
			>
				<Grid
					item
					xs={12}
					md={8}
					sx={{
						display: "flex",
						flexDirection: "column",
						justifyContent: "center",
						order: { xs: 2, md: 1 },
					}}
				>
					<Typography variant="body1" sx={descriptionStyles}>
						Our <strong>MD Purna Chandhar Rao Bellam</strong> started Annapurna
						Marriages Pvt Ltd. for match making service. Marriage is a bond
						which unities two souls in a wedlock, partnership that last till end
						scarps them apart. <strong>annapurnamarriages.com</strong> is an
						India's best-known marriage bureau and India's largest marriage
						services was founded with a simple objective is to introduce
						suitable life partners to the prospective Bride / Bride Groom.
					</Typography>
				</Grid>

				<Grid
					item
					xs={12}
					md={4}
					sx={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						order: { xs: 1, md: 2 },
					}}
				>
					<Box
						sx={{
							position: "relative",
							width: { xs: '150px', sm: "290px" },
							height: {xs:"200px",sm:"290px"},
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
						}}
					>
						<Box
							sx={{
								position: "absolute",
								width: { xs: '150px', sm: "100%" },
								height: { xs: '200px', sm: "100%" },
								border: "1px solid #d67e29",
								borderRadius: "15px",
								marginTop: {xs:2,sm:"-50px"},
								transform: "rotate(-2deg)",
							}}
						/>

						<Box
							sx={{
								position: "relative",
								overflow: "hidden",
								borderRadius: "12px",
								marginTop:{xs:"0px",sm:"-50px"},
								transform: "rotate(2deg)",
							}}
						>
							<img
								src="/images/Frame 141.png"
								alt="Founder"
								style={founderImageStyles}
							/>
						</Box>
					</Box>
				</Grid>
			</Grid>
		</Card>
	);
};

export default FounderSection;
